import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { PropTypes as MicromagPropTypes } from '@micromag/core';
import { ScreensProvider } from '@micromag/screens';

import ScreenListItem from '../items/ScreenList';

const propTypes = {
    story: MicromagPropTypes.story,
    items: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string,
            name: PropTypes.name,
        }),
    ),
    itemLink: PropTypes.string,
    withoutLink: PropTypes.bool,
    className: PropTypes.string,
};

const defaultProps = {
    story: null,
    items: [],
    itemLink: null,
    withoutLink: false,
    className: null,
};

const ScreensList = ({ story, items, itemLink, withoutLink, className }) => (
    <div
        className={classNames([
            {
                [className]: className !== null,
            },
        ])}
    >
        {items !== null && items.length > 0 ? (
            <ScreensProvider>
                {items.map((it, index) => {
                    const { parameters } = it || {};
                    const { metadata } = parameters || {};
                    const { title = null } = metadata || {};
                    return (
                        <ScreenListItem
                            key={`item-${it.id}`}
                            item={it}
                            link={itemLink}
                            linkParams={{
                                story: story.id,
                                screen: it.id,
                            }}
                            withoutLink={withoutLink}
                        >
                            <FormattedMessage defaultMessage="Screen" description="Screen" />
                            {` ${index + 1} (${it.type})`}
                            {title !== null ? ` - ${title}` : null}
                        </ScreenListItem>
                    );
                })}
            </ScreensProvider>
        ) : (
            <FormattedMessage
                defaultMessage="No screens in this story"
                description="No screens in this story label"
            />
        )}
    </div>
);

ScreensList.propTypes = propTypes;
ScreensList.defaultProps = defaultProps;

export default ScreensList;
